import moment from 'moment';
import { PrimaryContactModel } from '.';
export default class OrganizationModel {
  id: string;
  name: string;
  address: string;
  city: string;
  province: string;
  postalCode: string;
  telephoneNumber: string;
  primaryContacts: PrimaryContactModel[];
  faxNumber: string;
  webpage: string;
  userCount: number;
  updatedAt?: string;
  orgType?: string;
  wasAdmin?: boolean;
  position?: number;

  constructor(data?: any) {
    this.id = data?.id || undefined;
    this.name = data?.name || undefined;
    this.address = data?.address || undefined;
    this.city = data?.city || undefined;
    this.province = data?.province || undefined;
    this.postalCode = data?.postalCode || undefined;
    this.telephoneNumber = data?.telephoneNumber || undefined;
    this.primaryContacts = Array.isArray(data?.primaryContacts)
      ? data.primaryContacts.map(item => new PrimaryContactModel(item))
      : [];
    this.faxNumber = data?.faxNumber || undefined;
    this.webpage = data?.webpage || undefined;
    this.userCount = data?.userCount ?? undefined;
    this.updatedAt = data?.updatedAt ? moment.unix(data.updatedAt).format('ll') : undefined;
    this.orgType = data?.orgType || undefined;
    this.wasAdmin = data?.wasAdmin || 0;
    this.position = data?.position || undefined;
  }
}
